<template>
  <v-container fluid style="-webkit-app-region: no-drag">
    <div style="
        position: absolute;
        top: 10px;
        right: 10px;
      ">
      <v-btn style="-webkit-app-region: no-drag" small dark text @click="minimizeWindow">
        <v-icon>mdi-window-minimize</v-icon>
      </v-btn>
      <v-btn style="-webkit-app-region: no-drag" small text dark @click="fullscreenWindow(isFullscreen)">
        <v-icon>{{ isFullscreen ? 'mdi-dock-window' : 'mdi-window-maximize' }}</v-icon>
      </v-btn>
      <v-dialog v-model="dialog" persistent max-width="290">
        <template v-slot:activator="{ on, attrs }">
          <v-btn dark text v-bind="attrs" small v-on="on" style="-webkit-app-region: no-drag">
            <v-icon>mdi-power</v-icon>
          </v-btn>
        </template>
        <v-card>
          <v-card-title class="headline">
            Close the App?
          </v-card-title>
          <v-card-text>
            Are your sure you want to close the app?
            any unsaved changes made will be discarded.</v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn color="green darken-1" text @click="closeWindow" style="-webkit-app-region: no-drag">
              Ok
            </v-btn>
            <v-btn color="green darken-1" text @click="dialog = false" style="-webkit-app-region: no-drag">
              Cancel
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
    </div>
  </v-container>
</template>
<script>
import { closeApp, maximizeWindow, minimizeWindow } from '../../../lib/electron-utils'
export default {
  name: 'vAppBar',
  data() {
    return {
      isFullscreen: false,
      dialog: false,
    }
  },
  methods: {
    fullscreenWindow(fullscreen) {
      this.isFullscreen = maximizeWindow()
    },
    minimizeWindow: () => {
      minimizeWindow()
    },
    closeWindow: close => {
      // console.log()
      // console.log(ipcRenderer)
      if (close) closeApp()
    },
  },
}
</script>
